import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../api/api';
import CampaignCard from './CampaignCard';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const CampaignList = () => {
  const { t } = useTranslation();
  const [campaigns, setCampaigns] = useState([]);
  const titleRef = useScrollReveal();

  useEffect(() => {
    api.getCampaigns()
      .then((data) => {
        const sortedData = [...data].sort((a, b) => a.id - b.id).slice(1);
        setCampaigns(sortedData);
      })
      .catch(console.error);
  }, []);

  return (
    <section className="campaigns-list">
      <div className="container">
        <h2 ref={titleRef} className="section-title scroll-reveal">
          {t('campaigns.title')}
        </h2>

        <div id="campaignsContainer">
          {campaigns.map((campaign, index) => (
            <CampaignCard
              key={campaign.id}
              campaign={campaign}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampaignList;